import * as React from "react";
import { forwardRef } from "react";
const SvgWebhook = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 33 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	id: "Vector",
	d: "M5.16767 18.3942C4.25021 18.9691 3.49863 19.7735 2.9872 20.7278C2.47578 21.6822 2.22221 22.7535 2.25155 23.8358C2.2809 24.9182 2.59213 25.9742 3.15451 26.8994C3.71689 27.8246 4.51095 28.5871 5.45822 29.1115C6.40549 29.6359 7.47319 29.904 8.55581 29.8894C9.63843 29.8748 10.6985 29.578 11.6313 29.0282C12.5641 28.4785 13.3373 27.6949 13.8745 26.7548C14.4117 25.8147 14.6944 24.7507 14.6945 23.668H24.0284M21.0198 29.1155C21.8509 29.5742 22.776 29.8367 23.7242 29.8829C24.6724 29.929 25.6186 29.7576 26.4904 29.3817C27.3621 29.0058 28.1363 28.4355 28.7537 27.7143C29.3711 26.9931 29.8153 26.1402 30.0523 25.2209C30.2892 24.3016 30.3128 23.3402 30.121 22.4104C29.9292 21.4806 29.5273 20.6071 28.9459 19.8565C28.3645 19.106 27.6191 18.4985 26.7668 18.0804C25.9144 17.6624 24.9777 17.4449 24.0284 17.4446C22.9301 17.4446 21.8132 17.7231 20.9171 18.2225L16.2501 9.66615M22.4728 9.66615C22.4728 8.01577 21.8172 6.43297 20.6502 5.26597C19.4832 4.09897 17.9005 3.44336 16.2501 3.44336C14.5998 3.44336 13.0171 4.09897 11.8501 5.26597C10.6831 6.43297 10.0275 8.01577 10.0275 9.66615C10.0275 12.009 11.2254 14.0501 13.1388 15.1111L8.47188 23.6674",
	stroke: "#434343",
	strokeWidth: 2.2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgWebhook);
export default ForwardRef;
